module.exports = __webpack_public_path__ + "static/media/PP1-MacBook.0ca8a926.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Paper1/PP1-MacBook.png
// module id = 244
// module chunks = 0